<template>
  <v-expansion-panels class="my-4" flat>
    <v-expansion-panel class="history-panel">
      <v-expansion-panel-header class="subtitle-1 font-weight-bold">
        <div>
          Lịch sử thao tác<span v-if="logs.length" class="grey--text font-weight-regular ml-1"
            >({{ logs.length }})</span
          >
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div v-if="loading" class="py-2"><v-skeleton-loader type="list-item-three-line" /></div>
        <div v-else-if="!logs.length" class="py-2 grey--text">Chưa có Lịch sử thao tác.</div>
        <v-timeline v-else dense clipped class="pr-2">
          <v-timeline-item
            v-for="log in logs"
            :key="log.id"
            small
            fill-dot
            :color="actionColor(log.action)"
            :icon="actionIcon(log.action)"
          >
            <div class="d-flex justify-space-between flex-wrap">
              <div class="body-2">
                <span class="font-weight-medium">{{ changedByName(log) }}</span>
                <span class="grey--text text--darken-1"> · {{ actionLabel(log.action) }} · </span>
                <span>{{ log.entityLabel }}</span>
              </div>
              <div class="caption grey--text">{{ log.createdAt | ddmmyyyyhhmm }}</div>
            </div>
            <ul v-if="log.changes && log.changes.length" class="mt-1 mb-0 caption grey--text text--darken-2">
              <li v-for="(c, i) in log.changes" :key="i">
                <b>{{ c.label }}:</b> {{ c.from }} → {{ c.to }}
              </li>
            </ul>
          </v-timeline-item>
        </v-timeline>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { MealConfigLog } from '@/plugins/api'
import { LOG_ACTION_META } from '@/modules/mealConfig/mealConfigConstants'

/**
 * Panel Lịch sử thao tác config bữa ăn — tự fetch theo bộ lọc truyền vào.
 * Truyền MỘT trong các bộ lọc:
 *  - :slot-id  → mọi log của bữa (gồm áp dụng + khóa của bữa)
 *  - :group-id → mọi log của nhóm (gồm áp dụng + khóa nhắm vào nhóm)
 *  - entity + :entity-id → log của đúng 1 bản ghi
 * Dữ liệu log đã denormalized (render-ready), không cần populate.
 */
export default {
  name: 'MealConfigHistory',
  props: {
    entity: { type: String, default: null },
    entityId: { type: [String, Number], default: null },
    slotId: { type: [String, Number], default: null },
    groupId: { type: [String, Number], default: null }
  },
  data() {
    return { logs: [], loading: false }
  },
  computed: {
    query() {
      if (this.slotId) return { slotId: this.slotId }
      if (this.groupId) return { groupId: this.groupId }
      if (this.entity && this.entityId) return { entity: this.entity, entityId: this.entityId }
      return null
    }
  },
  watch: {
    // id của bữa/nhóm/khóa thường có sau khi trang detail fetch xong → refetch khi sẵn sàng
    query: {
      handler(v) {
        if (v) this.refresh()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async refresh() {
      this.loading = true
      try {
        this.logs = await MealConfigLog.fetch({ ...this.query, _sort: 'createdAt:DESC', _limit: -1 })
      } catch (e) {
        this.$alert.error('Không tải được Lịch sử thao tác: ' + e)
      } finally {
        this.loading = false
      }
    },
    changedByName(log) {
      return (log.changedBy && log.changedBy.name) || 'Hệ thống'
    },
    actionLabel(a) {
      return (LOG_ACTION_META[a] && LOG_ACTION_META[a].label) || a
    },
    actionColor(a) {
      return (LOG_ACTION_META[a] && LOG_ACTION_META[a].color) || 'grey'
    },
    actionIcon(a) {
      return (LOG_ACTION_META[a] && LOG_ACTION_META[a].icon) || 'mdi-information'
    }
  }
}
</script>

<style scoped>
/* Viền nhẹ cho giống các card outlined khác trên trang */
.history-panel {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
